import { render, staticRenderFns } from "./c-spare-part-list.vue?vue&type=template&id=588de7fa&scoped=true"
import script from "./c-spare-part-list.vue?vue&type=script&lang=js"
export * from "./c-spare-part-list.vue?vue&type=script&lang=js"
import style0 from "./c-spare-part-list.vue?vue&type=style&index=0&id=588de7fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588de7fa",
  null
  
)

export default component.exports